import { render } from "./dingdanList.vue?vue&type=template&id=5e80d603&scoped=true"
import script from "./dingdanList.vue?vue&type=script&lang=js"
export * from "./dingdanList.vue?vue&type=script&lang=js"

import "./dingdanList.vue?vue&type=style&index=0&id=5e80d603&lang=scss&scoped=true"

import exportComponent from "G:\\web2\\豪哥\\盘龙山陵园\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e80d603"]])

export default __exports__